import type { FaireProductEntity } from "../../entity_types/product";

export const p_j39ztreaub: FaireProductEntity = {
  token: "p_j39ztreaub",
  type: "product",
  name: "Doctor Goodwin",
  brandToken: "b_2ncsmapy03",
  brandName: "Olipop",
  imageUrl:
    "https://cdn.faire.com/fastly/6d9b845a53bee0d5009eded8f48b57506a86504443a73bea424eb564c25264c1.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4f5ec686f04236755ccf364989abc3c759cad62981c1392bce517816a4463e96.png",
    "https://cdn.faire.com/fastly/9fdb9886ed462d3655ae970cbff32ff86f2ecbdcbcbbbe1c156297c4f61b9c02.png",
    "https://cdn.faire.com/fastly/105836d27c3694373b0a4b3e29df37e208bcc67abd191bacee774be9af44fb42.png",
    "https://cdn.faire.com/fastly/43a0aeeb62dc371cdf7602e7eab94523a26668f275b2cb9c97db4277a8d3e523.png",
  ],
  priceDollars: 28.99,
  description:
    "Crack open a swift kick of boldly refreshing flavors. Doctor Goodwin is a head-on collision of ingredients like rich plums, sweet prunes and zesty tart cherries with a touch of pure vanilla extract for a true soda enigma the Doctor would actually order.\n\nWholesale cost offers landed cost of $2.42 per unit, which provides a 40% gross margin to the retailer at $3.99 MSRP.",
  tags: [],
  msrpDollars: 57.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-30T17:24:13.282Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
